/**
 * Logo oficial de HIT TCG.
 *
 * Renderizamos la imagen PNG con transparencia (`/logo.png`, exportada a
 * 1024×1024 y padding neutral). Al lado, mantenemos el wordmark "HIT TCG"
 * como texto para SEO — Google indexa el texto real, no el alt del logo.
 *
 * En pantallas < 640px ocultamos el wordmark y dejamos solo el mark
 * para no comer espacio del header (ya hay tabs de navegación mobile abajo).
 */
export function Logo({ small = false }) {
  const box = small ? "h-7 w-7" : "h-10 w-10 sm:h-11 sm:w-11";
  const wordSize = small ? "text-base" : "text-xl sm:text-2xl";
  return (
    <div className="flex items-center gap-2 sm:gap-2.5">
      <img
        src="/logo.png"
        alt="HIT TCG"
        width={44}
        height={44}
        className={`${box} object-contain shrink-0 drop-shadow-[0_2px_8px_rgba(239,68,68,0.35)]`}
        loading="eager"
        decoding="async"
      />
      <div className={`${wordSize} font-display flex items-baseline gap-1 ${small ? "" : "hidden xs:flex sm:flex"}`}>
        <span className="text-white">HIT</span>
        <span className="text-[#EF4444]">TCG</span>
      </div>
    </div>
  );
}
